module.exports = __webpack_public_path__ + "img/4.fa681122.jpg";